import { Box, Skeleton } from '@mui/material';
import { FC } from 'react';
import {
  RequestDateAvalableStatusIcon,
  RequestDateNotAvailableStatusIcon,
  RequestDateStatus
} from '../request-date-item.styles';

export interface AvailabilityStatusProps {
  isLoading: boolean;
  isAvailable?: boolean;
  availabilityUnknown: boolean;
}

export const AvailabilityStatus: FC<AvailabilityStatusProps> = (props) => {
  const { isLoading, isAvailable, availabilityUnknown } = props;

  if (isLoading) {
    return (
      <RequestDateStatus>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Skeleton variant="circular" width={10} height={10} sx={{ marginRight: '5px' }} />
          <Skeleton variant="text" width={70} height={15} />
        </Box>
      </RequestDateStatus>
    );
  }

  if (availabilityUnknown) return null;

  return (
    <RequestDateStatus>
      {isAvailable && (
        <>
          <RequestDateAvalableStatusIcon />
          Available
        </>
      )}
      {!isAvailable && (
        <>
          <RequestDateNotAvailableStatusIcon />
          Not Available
        </>
      )}
    </RequestDateStatus>
  );
};
